import { RouteTimelineDtoModelType } from '../models';

export const getOrderTimelineEventsBySequenceAscendingly = (timeline: RouteTimelineDtoModelType[]): RouteTimelineDtoModelType[] => {
  const latestRouteSolutionId = Math.max(...timeline.map(r => r.routeSolutionId ?? 0));
  return timeline
    .filter(r => r.routeSolutionId === latestRouteSolutionId)
    .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0));
};
